import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useScreenSize } from "hooks";
import { BackIcon } from "components/atoms/Icon";
import { Typography } from "components/atoms";
import { PracticeMobileModalInnerCard } from "components/molecules";
import "./index.scss";

interface IProps {
  theme: "light" | "dark";
}

export const PracticeModalMobileScreen = ({ theme }: IProps) => {
  const [deliveryType, setDeliveryType] = useState("bubble");
  const [onlineProctor_1, setOnlineProctor_1] = useState("");
  const [onlineProctor_2, setOnlineProctor_2] = useState("");
  const [onlineProctor_3, setOnlineProctor_3] = useState("");
  const [onlineBtnUrl, setOnlineBtnUrl] = useState("");
  const [bubbleBtnUrl, setBubbleBtnUrl] = useState("");
  const [pdfUrl, setPdfUrl] = useState("");

  const location = useLocation();
  const navigate = useNavigate();
  const screen = useScreenSize();
  const item = location.state.item;

  useEffect(() => {
    switch (item.LaunchTests.length) {
      case 2:
        setDeliveryType("both");
        setPdfUrl(item.PdfUrl);
        if (item.LaunchTests[0].DeliveryType === "Online") {
          if (item.LaunchTests[0].LaunchUrl) {
            setOnlineBtnUrl(item.LaunchTests[0].LaunchUrl);
          }
          if (item.LaunchTests[1].LaunchUrl) {
            setBubbleBtnUrl(item.LaunchTests[1].LaunchUrl);
          }
          if (item.LaunchTests[1].ProctorUrl) {
            setOnlineProctor_1(
              item.LaunchTests[1].ProctorUrl["Online Proctor"]
            );
            setOnlineProctor_2(
              item.LaunchTests[1].ProctorUrl["Online Proctor 1.5x Timer"]
            );
            setOnlineProctor_3(
              item.LaunchTests[1].ProctorUrl["Online Proctor 2x Timer"]
            );
          }
        } else {
          if (item.LaunchTests[1].LaunchUrl) {
            setOnlineBtnUrl(item.LaunchTests[1].LaunchUrl);
          }
          if (item.LaunchTests[0].LaunchUrl) {
            setBubbleBtnUrl(item.LaunchTests[0].LaunchUrl);
          }

          if (item.LaunchTests[0].ProctorUrl) {
            setOnlineProctor_1(
              item.LaunchTests[0].ProctorUrl["Online Proctor"]
            );
            setOnlineProctor_2(
              item.LaunchTests[0].ProctorUrl["Online Proctor 1.5x Timer"]
            );
            setOnlineProctor_3(
              item.LaunchTests[0].ProctorUrl["Online Proctor 2x Timer"]
            );
          }
        }
        break;
      case 1:
        setDeliveryType("bubble");
        setPdfUrl(item.PdfUrl);
        if (item.LaunchTests[0].LaunchUrl) {
          setBubbleBtnUrl(item.LaunchTests[0].LaunchUrl);
        }
        if (item.LaunchTests[0].ProctorUrl) {
          setOnlineProctor_1(item.LaunchTests[0].ProctorUrl["Online Proctor"]);
          setOnlineProctor_2(
            item.LaunchTests[0].ProctorUrl["Online Proctor 1.5x Timer"]
          );
          setOnlineProctor_3(
            item.LaunchTests[0].ProctorUrl["Online Proctor 2x Timer"]
          );
        }
        break;
      default:
        break;
    }
  }, []);

  useEffect(() => {
    if (screen.width > 685) {
      navigate("/practice");
    }
  }, [screen.width]);

  const handleBack = () => {
    navigate("/practice");
  };

  return (
    <div className="practice-mobile-modal-wrapper">
      <div className="back-section">
        <div className="back-icon" onClick={handleBack}>
          <BackIcon color={theme === "light" ? "#233851" : "#329EE2"} />
        </div>
        <div className="typography-section">
          <Typography label="Back" variant="h6Medium" onClick={handleBack} />
        </div>
      </div>

      <div className="online-section">
        {deliveryType === "both" ? (
          <PracticeMobileModalInnerCard
            theme={theme}
            type="online"
            btnLabel="Launch Online Test"
            description="Complete all the questions in this section and see your results and the explanations at the end"
            launchUrl={onlineBtnUrl}
          />
        ) : null}
        <PracticeMobileModalInnerCard
          theme={theme}
          type="bubble"
          btnLabel="Launch Bubblesheet"
          description="Complete all the questions in this section by entering your answers in a bubblesheet"
          launchUrl={bubbleBtnUrl}
          pdfUrl={pdfUrl}
          isPdfUrl={pdfUrl === "" ? false : true}
        />
      </div>
    </div>
  );
};
